/**
 * Styled Components - Created by david on 26/02/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const Text = styled.div`
  color: #5f6062;
  font-size: 12px;
  line-height: 19px;
  margin-top: 4px;
  text-align: center;
`
export const Icon = styled.img``



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/DesignerTool/DesignCenterCustomize/Tab/styledComponents.tsx